import React from 'react';
import PropTypes from 'prop-types';
import isRequiredIf from 'react-proptype-conditional-require';
import ArrowLeft from '@deliveroo/icon-set/react/ArrowLeft';
import IconWithText from '@deliveroo/consumer-component-library/components/IconWithText';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import withPlaceholder from '@deliveroo/consumer-component-library/components/withPlaceholder';
import styles from './styles.scss';

const HomeTitle = ({ title, titleLink, onClick, isPlaceholder }) => (
  <div>
    {titleLink && (
      <button type="button" className={styles.button} onClick={onClick}>
        <IconWithText
          component={ArrowLeft}
          color="teal"
          size="small"
          spacing="0 x-small 0 0"
          isPlaceholder={isPlaceholder}
        >
          {titleLink}
        </IconWithText>
      </button>
    )}
    <Heading level={3} color="black" isPlaceholder={isPlaceholder}>
      {title}
    </Heading>
  </div>
);

HomeTitle.propTypes = {
  title: isRequiredIf(PropTypes.string, (props) => !props.isPlaceholder),
  titleLink: PropTypes.string,
  onClick: isRequiredIf(PropTypes.func, (props) => !props.isPlaceholder),
  isPlaceholder: PropTypes.bool,
};

HomeTitle.defaultProps = {
  title: undefined,
  titleLink: null,
  onClick: undefined,
  isPlaceholder: false,
};

HomeTitle.placeholderProps = {
  title: 'placeholder',
  titleLink: 'placeholder link',
};

export default withPlaceholder(HomeTitle);
